{
  "app": {
    "name": "Cadence",
    "tagline": "Dance school management"
  },
  "nav": {
    "dashboard": "Dashboard",
    "students": "Students",
    "teachers": "Teachers",
    "families": "Families",
    "classes": "Classes",
    "events": "Events",
    "mailing": "Mailing",
    "media": "Media",
    "accounting": "Accounting",
    "reporting": "Reports",
    "audit": "Audit Log",
    "settings": "Settings"
  },
  "break": {
    "notice": "Break period",
    "body": "Classes are suspended this month and some fees may be paused or reduced."
  },
  "audit": {
    "title": "Audit Log",
    "lede": "A read-only record of significant actions across the system — who did what, and when.",
    "system": "System",
    "clear": "Clear filters",
    "allActions": "All actions",
    "allEntities": "All types",
    "allUsers": "All users",
    "searchPlaceholder": "Search action, entity, details, IP, user…",
    "prev": "Previous",
    "next": "Next",
    "showing": "Showing {from}–{to} of {total}",
    "empty": "No audit entries",
    "emptyFiltered": "No entries match the current filters.",
    "detailTitle": "Audit entry",
    "details": "Details",
    "userAgent": "User agent",
    "filters": {
      "search": "Search",
      "action": "Action",
      "entity": "Entity type",
      "user": "User",
      "from": "From",
      "to": "To"
    },
    "col": {
      "when": "When",
      "actor": "Who",
      "action": "Action",
      "entity": "Entity",
      "ip": "IP"
    }
  },
  "portalNav": {
    "dashboard": "Home",
    "classes": "My Classes",
    "levels": "My Levels",
    "payments": "Payments",
    "events": "Events",
    "calendar": "Calendar",
    "gallery": "Gallery",
    "profile": "Profile",
    "contract": "Terms"
  },
  "calendar": {
    "title": "Subscribe to calendar",
    "lede": "Add your classes, events and payment due dates to your own calendar app. The feed updates automatically — subscribe once and it stays in sync.",
    "feedUrl": "Your private calendar feed",
    "copy": "Copy URL",
    "copied": "Calendar URL copied",
    "copyFailed": "Couldn't copy — select and copy the URL manually",
    "subscribe": "Subscribe",
    "readOnlyNote": "This link is private to you and read-only. Anyone with it can see your schedule, so don't share it.",
    "disabledHeading": "Calendar is turned off",
    "disabledMessage": "The calendar feature isn't available right now. Check back later or ask your school.",
    "google": "Google Calendar",
    "googleStep1": "Open Google Calendar on the web.",
    "googleStep2": "Next to \"Other calendars\", click + then \"From URL\".",
    "googleStep3": "Paste the feed URL above and click \"Add calendar\".",
    "openGoogle": "Add to Google Calendar",
    "apple": "Apple Calendar",
    "appleStep1": "In Calendar, choose File → New Calendar Subscription.",
    "appleStep2": "Paste the feed URL above and click Subscribe.",
    "appleStep3": "Pick a refresh interval and click OK.",
    "outlook": "Outlook",
    "outlookStep1": "In Outlook, go to Add calendar → Subscribe from web.",
    "outlookStep2": "Paste the feed URL above.",
    "outlookStep3": "Name the calendar and click Import."
  },
  "search": {
    "placeholder": "Search students…",
    "noResults": "No matches"
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "logout": "Log out",
    "toggleTheme": "Toggle theme",
    "collapseSidebar": "Collapse sidebar",
    "openMenu": "Open menu",
    "continue": "Continue",
    "back": "Back"
  },
  "states": {
    "loading": "Loading…",
    "empty": "Nothing here yet"
  },
  "header": {
    "userMenu": "User menu",
    "notifications": "Notifications",
    "language": "Language"
  },
  "a11y": {
    "primaryNav": "Primary",
    "portalNav": "Portal"
  },
  "cookies": {
    "title": "Cookies",
    "body": "We use only the cookies strictly necessary to keep you signed in and run this site. No tracking, analytics, or advertising.",
    "learnMore": "What cookies?",
    "hide": "Hide details",
    "itemSession": "Session cookies — keep you signed in to the admin and student areas.",
    "itemPrefs": "Preferences — your language and light/dark choice (stored on this device).",
    "itemNoTracking": "No third-party, tracking, analytics, or advertising cookies are used.",
    "accept": "Got it"
  },
  "title": {
    "admin": "Administration",
    "portal": "Student portal"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications yet",
    "markAllRead": "Mark all read",
    "unread": "{count} unread"
  },
  "onboarding": {
    "welcome": "Welcome to {school}",
    "subtitle": "Let’s set up your account in a few quick steps.",
    "stepContract": "Terms",
    "stepPassword": "Password",
    "stepProfile": "Profile",
    "agree": "I have read and agree to the above terms and conditions",
    "noContract": "No terms have been published yet. Please contact the school.",
    "passwordHint": "Use at least 8 characters.",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "mismatch": "Passwords do not match",
    "weak": "Password must be at least 8 characters",
    "finish": "Finish",
    "completed": "All set! Taking you to your portal…",
    "invalid": "This onboarding link is invalid or has already been used."
  },
  "portal": {
    "welcome": "Welcome back, {name}",
    "upcomingClasses": "Upcoming classes",
    "payments": "Outstanding payments",
    "paymentsEmpty": "You’re all paid up.",
    "levels": "My levels",
    "events": "Upcoming events",
    "eventsEmpty": "No events scheduled.",
    "quickLinks": "Quick links",
    "noClasses": "You’re not enrolled in any classes yet.",
    "noLevels": "No levels assigned yet.",
    "willAttend": "I’ll attend",
    "wontAttend": "Can’t make it",
    "attending": "Attending",
    "notAttending": "Not attending",
    "absent": "Marked absent",
    "profileTitle": "My profile",
    "bio": "Bio",
    "bioPlaceholder": "Tell us a little about yourself…",
    "saveBio": "Save",
    "contractTitle": "Terms & Conditions",
    "acceptedOn": "Accepted on {date} (version {version})",
    "noContract": "You haven’t accepted any terms yet."
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "notFound": "Page not found",
    "notFoundBody": "The page you’re looking for doesn’t exist."
  }
}
